import { sorted } from "helpers";

export const orderByMetadata = <Entry extends { ordering: number }>(
  entries: Entry[]
): Entry[] => sorted(entries, (entry) => entry.ordering);
